module.exports = __webpack_public_path__ + "static/1StoreIcons-31f8e05d9312d2b1b7fd9692de564333.svg";